import { useEffect, useState } from 'react';

import sortBy from 'lodash/sortBy';

import { useSegmentEvent } from 'src/app/hooks/useSegmentEvent';
import type { CheckoutDeliveryWindow, DeliveryWindow } from 'src/app/types';
import { formatDeliveryWindowTimeRange, isSameDayWindowAvailable } from 'src/app/utils';

export const useRescheduleAnalytics = (
  orderId: string,
  hasLoaded: boolean,
  rescheduleDeliveryWindows?: CheckoutDeliveryWindow[] | null
) => {
  const dispatchViewRescheduleDeliveryWindow = useSegmentEvent('viewRescheduleDeliveryWindow', {
    shouldTrackOnMount: false,
  });
  const [hasEventBeenSent, setEventHasBeenSent] = useState(false);
  useEffect(() => {
    if (!hasEventBeenSent && hasLoaded && orderId) {
      const flattenedDeliveryWindows = rescheduleDeliveryWindows?.reduce((result, current) => {
        current?.deliveryWindows?.forEach(deliveryWindow => result.push(deliveryWindow));
        return result;
      }, [] as DeliveryWindow[]);
      const hasSameDayDelivery =
        (flattenedDeliveryWindows && isSameDayWindowAvailable(flattenedDeliveryWindows)) || false;
      const windowsAvailableCount = flattenedDeliveryWindows?.length || 0;
      const earliestWindow = sortBy(flattenedDeliveryWindows, ['startDate'])[0];
      const formattedEarliestWindow = earliestWindow
        ? formatDeliveryWindowTimeRange(
            earliestWindow?.startDate,
            earliestWindow?.endDate,
            earliestWindow?.category,
            earliestWindow?.facilityTimezone
          )
        : 'No Available Windows';
      dispatchViewRescheduleDeliveryWindow({
        order_id: orderId,
        source: 'order details',
        selected_date: 'No Date Selected',
        selected_window: 'No Window Selected',
        same_day_availability: hasSameDayDelivery,
        windows_available_count: windowsAvailableCount,
        earliest_window: formattedEarliestWindow,
      });
      setEventHasBeenSent(true);
    }
  }, [dispatchViewRescheduleDeliveryWindow, hasEventBeenSent, hasLoaded, orderId, rescheduleDeliveryWindows]);
};
